<template>
    <div class="app">
        <HeaderCheckout />

        <GroupDefault />

        <FooterCheckout />
    </div>
</template>

<script setup>
import HeaderCheckout from '@/components/Header/HeaderCheckout.vue'
import FooterCheckout from '@/components/Footer/FooterCheckout.vue'
import GroupDefault from '@/components/Group/GroupDefault.vue'
</script>